export default __webpack_public_path__ + "static/media/3.94d06b6d.jpg";